<template>
  <v-container class="grey lighten-5">
    <h2>Live Kurs: {{ course.name }}</h2>
    <br/>

    <v-card>
      <v-card-title>CSV Upload für neue Nutzer</v-card-title>
      <v-card-text>
        <v-file-input
            truncate-length="24"
            accept="text/csv"
            @change="fileSelected"
            label="CSV Datei auswählen"
        ></v-file-input>
        <v-btn class="ma-1" color="info" :loading="loading"
               :disabled="loading || csv == null || course == null" @click="uploadCsv">
          CSV hochladen
          <template v-slot:loader>
              <span class="custom-loader">
                <v-icon light>mdi-cached</v-icon>
              </span>
          </template>
        </v-btn>
      </v-card-text>
    </v-card>

    <br/>
    <h3>Teilnehmer</h3>
    <v-row>
      <v-col>
        <v-card v-for="participant in course.participants" :key="participant.userName" style="margin-bottom: 8px;"
                outlined
                tile
        >
          <v-card-title>{{ participant.name }} | username: {{ participant.userName }}</v-card-title>
          <v-card-subtitle>
            <p v-if="participant.courseRunDTO.isSuccess" class="pb-0" style="font-size: larger">
              Absolviert am {{ participant.courseRunDTO.courseRunDetails.successDate | moment("DD.MM.YYYY HH:mm") }}
            </p>
            <p v-else-if="participant.courseRunDTO.isError" class="pb-0">
              Durchgefallen am {{ participant.courseRunDTO.courseRunDetails.failureDate | moment("DD.MM.YYYY HH:mm") }}
            </p>
            <p v-else-if="participant.courseRunDTO.courseRunDetails.startDate" class="pb-0">
              Gestartet am {{ participant.courseRunDTO.courseRunDetails.startDate | moment("DD.MM.YYYY HH:mm") }}
            </p>
            <div
                v-if="participant.courseRunDTO.finishUntil && !participant.courseRunDTO.isSuccess && !participant.courseRunDTO.isError">
              <b>Zeit bis: {{ participant.courseRunDTO.finishUntil | moment("DD.MM.YYYY HH:mm") }}</b></div>

            <p v-if="participant.courseRunDTO.isCompound" style="word-break: break-word">Mehrteilig</p>


          </v-card-subtitle>
          <v-card-text>
            <div v-if="participant.courseRunDTO.compoundParts.length>0">
              <h2 style="margin-top: 24px">Kursteile</h2>
              <br/>
              <v-row>
                <v-col
                    v-for="part in participant.courseRunDTO.compoundParts"
                    :key="participant.courseRunDTO.partId"
                    cols="12"
                    sm="4"
                >
                  <CoursePartOverview @downloadShippers="downloadShippers(part, participant)"
                                      @downloadDeclaredGoods="downloadDeclaredGoods(part, participant)"
                                      :admin="true" :part="part"
                                      @approve="approve(part, participant)"
                                      @deny="deny(part, participant)"
                                      @start="executingCoursePartRun = part"/>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar :timeout="5000" :value="success" color="primary" left shaped top app>Gespeichert</v-snackbar>
    <v-snackbar :timeout="5000" :value="error" color="error" left shaped top>Fehler.</v-snackbar>
  </v-container>

</template>

<script>

import CourseRun from "@/components/CourseExecution.vue";
import Course from "@/models/Course";
import {default as CourseRunModel} from "@/models/CourseRun";
import LiveCourse from "@/models/LiveCourse";
import ShippersDeclarationModel from "@/models/ShippersDeclarationModel";
import CoursePartOverview from "@/components/CoursePartOverview.vue";

export default {
  name: "SuperAdminLiveCourse",
  components: {CoursePartOverview},
  data: () => ({
    course: null,
    loading: false,
    success: false,
    error: false,
    csv: null,
    interval: null
  }),
  props: {
    liveId: {
      type: String
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods: {
    uploadCsv() {
      this.loading = true;
      this.$httpLiveCourseApi.upload(this.csv, this.liveId, () => {
        this.loading = false;
        this.successText = "Erfolgreich hochgeladen"
        this.success = true;
        setTimeout(() => {
          this.success = false;
        }, 3000);
        this.pdf = null;
      }, () => {
        this.loading = false;
        this.errorText = "Fehler beim Hochladen der Datei."
        this.error = true;
        setTimeout(() => this.error = false, 5000);
      })
    },
    approve(item, participant) {
      this.loading = true;
      this.$httpLiveCourseApi.approveShippers(this.liveId, participant.id, () => {
        this.loading = false;
        this.successText = "Erfolgreich"
        this.success = true;
        setTimeout(() => {
          this.success = false;
        }, 3000);
        this.pdf = null;
      }, () => {
        this.loading = false;
        this.errorText = "Fehler."
        this.error = true;
        setTimeout(() => this.error = false, 5000);
      })
    },
    deny(item, participant) {
      this.loading = true;
      this.$httpLiveCourseApi.denyShippers(this.liveId, participant.id, () => {
        this.loading = false;
        this.successText = "Erfolgreich"
        this.success = true;
        setTimeout(() => {
          this.success = false;
        }, 3000);
        this.pdf = null;
      }, () => {
        this.loading = false;
        this.errorText = "Fehler"
        this.error = true;
        setTimeout(() => this.error = false, 5000);
      })
    },
    downloadShippers(item, participant) {
      this.$httpLiveCourseApi.downloadShippers(this.liveId, participant.id, "shippers_" + participant.userName);
    },
    downloadDeclaredGoods(item, participant) {
      this.$httpLiveCourseApi.downloadDeclaredGoods(this.liveId, participant.id, "declared_goods_" + participant.userName);
    },
    loadData() {
      this.$httpLiveCourseApi.get(this.liveId, (result) => {
        this.course = result;
      });
    },
    fileSelected(file) {
      this.csv = file;
    },
  },
  mounted() {
    this.loadData();
    this.interval = setInterval(function () {
      this.loadData();
    }.bind(this), 9000);
  }
}
</script>

<style scoped>

</style>
